﻿; (() => {
    const section = document.querySelector('.products-section');
    if (!section) return;

    const grid = section.querySelector('.bg-grid');
    if (!grid) return;

    const reduceMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
    if (reduceMotion) return;

    const intensity = 0.15;
    let ticking = false;

    function update() {
        const rect = section.getBoundingClientRect();
        const offset = rect.top * intensity;

        grid.style.setProperty('--parallax-y', offset.toFixed(2) + 'px');
        ticking = false;
    }

    function onScroll() {
        if (ticking) return;
        ticking = true;
        requestAnimationFrame(update);
    }

    update(); // initial paint
    window.addEventListener('scroll', onScroll, { passive: true });
    window.addEventListener('resize', onScroll);
})();